import WinLossStatementsModule from './WinLossStatementsModule';

export default WinLossStatementsModule;
